module.exports = __webpack_public_path__ + "img/home-icon.5a8ff412.png";